import {CSSProperties} from "react";
import {isUndefined} from "../base";


export function isNumeric(val: string | number): boolean {
    return typeof val === 'number' || /^\d+(\.\d+)?$/.test(val);
}

export const css = Object.freeze({
    symbol(value: string | number | undefined): string | undefined {
        if (isUndefined(value)) {
            return undefined
        }
        value = String(value)
        return isNumeric(value) ? `${value}px` : value
    },
    Size: {
        toStyle(value?: string | number): CSSProperties {
            if (isUndefined(value)) {
                return {}
            }
            const size = css.symbol(value);
            return {
                width: size,
                height: size
            }
        }
    }
})